import { Path } from '@src/suite/common/data-models/complex-types/path';
import { NavigationGroup, NavigationGroupTypes, NavigationLayoutTypes, NavigationSection } from '@src/suite/common/store/navigation/models/navigation.models';

export const getSectionsCopy = (sections: NavigationSection[]): any => {
    return sections.map((section, index) => {
        return {
            Opened: section.Opened,
            inEditMode: false,
            isNewSection: false,
            PrevOpened: false,
            ID: section.ID,
            Label: section.Label,
            Order: index,
            Hidden: section.Hidden,
            Enterprise: section.Enterprise,
            Items: section.Items.map((item, idx) => {
                return {
                    SectionID: item.SectionID,
                    Label: item.Label,
                    Database: item.Database,
                    Path: item.ViewState.Path.fullPath,
                    Guid: item.ViewState.Guid,
                    Hidden: item.Hidden,
                    System: item.System,
                    ViewState: null,
                    SectionPath: item.SectionPath,
                    GroupPath: item.GroupPath,
                    Url: null,
                    IsDefault: item.IsDefault,
                    Order: idx,
                };
            }),
        };
    });
};

export const getGroupLayout = (group: NavigationGroup): NavigationLayoutTypes => {
    let layout = NavigationLayoutTypes.User;
    if (group.ID === NavigationGroupTypes.Global) {
        layout = NavigationLayoutTypes.Enterprise;
    }
    if (group.ID === NavigationGroupTypes.Team) {
        layout = NavigationLayoutTypes.Group;
    }

    return layout;
};

export const getTeam = (group: NavigationGroup, currentPlaybookTeam: string): string => {
    let team = '';
    if (group.ID === NavigationGroupTypes.Team) {
        team = currentPlaybookTeam;
    }
    return team;
};

export const getPath = (group: number, currentPlaybookTeam: string, enterpriseTeam: string, user: string): Path => {
    let path = '';
    if (group === NavigationGroupTypes.Global) {
        path = `P_${enterpriseTeam}\\VS`;
    }
    if (group === NavigationGroupTypes.Team) {
        if (currentPlaybookTeam) path = `P_${currentPlaybookTeam}\\VS`;
        else path = `P_${enterpriseTeam}\\VS`;
    }
    if (group === NavigationGroupTypes.Personal || !group) {
        path = `U_${user}\\VS`;
    }

    return new Path(path);
};

export const getGroupCopy = (sections: NavigationSection[]): any => {
    return sections.map((section, index) => {
        return {
            Opened: section.Opened,
            inEditMode: false,
            isNewSection: false,
            PrevOpened: false,
            ID: section.ID,
            Label: section.Label,
            Order: index,
            Hidden: section.Hidden,
            Enterprise: section.Enterprise,
            Items: section.Items.map((item, idx) => {
                return {
                    SectionID: item.SectionID,
                    Label: item.Label,
                    Database: item.Database,
                    Path: item.ViewState.Path.fullPath,
                    Guid: item.ViewState.Guid,
                    Hidden: item.Hidden,
                    System: item.System,
                    ViewState: null,
                    SectionPath: item.SectionPath,
                    GroupPath: item.GroupPath,
                    Url: null,
                    Order: idx,
                };
            }),
        };
    });
};

export const getGroupByID = (id: NavigationGroupTypes, enterprise: NavigationGroup, team: NavigationGroup, personal: NavigationGroup): NavigationGroup | null => {
    switch (id) {
        case NavigationGroupTypes.Global:
            return enterprise;
        case NavigationGroupTypes.Team:
            return team;
        case NavigationGroupTypes.Personal:
            return personal;
        default:
            return null;
    }
};
